import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Layout, Select } from "antd";
import { useNavigate } from "react-router";
import { Post } from "../../config/api/post";
import { Get } from "../../config/api/get";
import { SERVICES, COACH } from "../../config/constants/api";
import { addUser } from "../../redux/slice/authSlice";
import swal from "sweetalert";
import { FaArrowLeft } from "react-icons/fa";
import { BsFiles } from "react-icons/bs";
import "../profile/profile.css";
import "./services.css";

const navItems = [
  { label: "Profile", path: "/profile" },
  { label: "Education", path: "/education" },
  { label: "Meetings", path: "/meetings" },
  { label: "Subjects", path: "/subjects" },
  { label: "Services", path: "/services" },
  { label: "Hourly Rates", path: "/rates" },
  { label: "Rating & Review", path: "/review" },
  { label: "My Meetings", path: "/my-meetings" },
  { label: "My Assesments", path: "/my-assesments" },
];

const colors = ["#FFEBF6", "#E7FAFF", "#ECE7FF", "#D7FDC3"];

function Services() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [myServices, setMyServices] = useState([]);
  const [services, setServices] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (user) {
      setMyServices(user?.service || []);
    }
    getAllServices();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getAllServices = () => {
    try {
      Get(SERVICES.getAll).then((response) => {
        if (response?.status) {
          setServices(response?.data?.docs);
        } else {
          console.log("response", response);
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const getServiceTitle = (id) => {
    if (!services?.length) return "";
    return services.find((item) => item._id === id)?.title || "";
  };

  const updateServices = () => {
    setLoading(true);
    if (myServices?.length === 0) {
      swal("Error!", "Atleast one service is required", "error");
      setLoading(false);
      return;
    }

    Post(COACH.updateProfile, { service: myServices }, token, null)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          dispatch(addUser({ user: response.data.data, token: token }));
          swal("Success!", "Services Updated Successfully", "success");
          setLoading(false);
          setEditMode(false);
        } else {
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Layout className="profile-page">
      <section className="profile-hero">
        <div className="profile-wrap profile-hero-inner">
          <button
            type="button"
            className="services-back"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <FaArrowLeft />
            Back
          </button>
          <h1 className="fontFamily1 profile-hero-title">Services</h1>
          <p className="fontFamily1 profile-hero-sub">
            Choose and manage the services you offer on WrightCo Academy.
          </p>
        </div>
      </section>

      <div className="profile-wrap profile-main">
        <div className="profile-layout">
          <aside className="profile-nav">
            <p className="profile-nav-title">Account</p>
            <ul className="profile-nav-list">
              {navItems.map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    className={`profile-nav-item${
                      item.path === "/services" ? " is-active" : ""
                    }`}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <section className="profile-panel">
            <div className="profile-panel-head">
              <div>
                <h2 className="fontFamily1 profile-panel-title">
                  Your Services
                </h2>
                <p className="profile-panel-sub">
                  {editMode
                    ? "Select one or more services, then save your changes."
                    : "Services currently linked to your trainer profile."}
                </p>
              </div>
            </div>

            {myServices?.length === 0 ? (
              <div className="services-empty">
                <BsFiles aria-hidden />
                <p>No Services Found</p>
              </div>
            ) : (
              <div className="services-grid">
                {myServices.map((item, index) => (
                  <div
                    key={`${item}-${index}`}
                    className="services-chip"
                    style={{
                      backgroundColor:
                        colors[Math.floor(index / 4) % colors.length],
                    }}
                  >
                    {getServiceTitle(item) || "—"}
                  </div>
                ))}
              </div>
            )}

            {editMode && (
              <div className="services-edit-row">
                <label className="services-edit-label" htmlFor="services-select">
                  Add Services
                </label>
                <Select
                  id="services-select"
                  size="large"
                  mode="multiple"
                  maxTagCount="responsive"
                  className="signupSelectBox services-select"
                  placeholder="Select Services"
                  showSearch
                  optionFilterProp="children"
                  value={myServices}
                  onChange={(e) => setMyServices(e)}
                  style={{ minWidth: "100%" }}
                >
                  {services.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.title}
                    </option>
                  ))}
                </Select>
              </div>
            )}

            <div className="profile-actions">
              {!editMode ? (
                <Button
                  type="primary"
                  className="profile-btn-primary"
                  onClick={() => setEditMode(true)}
                >
                  Edit Services
                </Button>
              ) : (
                <>
                  <Button
                    type="primary"
                    className="profile-btn-primary"
                    loading={loading}
                    onClick={() => updateServices()}
                  >
                    {loading ? "Loading..." : "Update Services"}
                  </Button>
                  <Button
                    className="profile-btn-ghost"
                    ghost
                    size="large"
                    onClick={() => {
                      setMyServices(user?.service || []);
                      setEditMode(false);
                    }}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
}

export default Services;
